document.addEventListener("DOMContentLoaded", function () {
    // SchoolListElement: Limit visible letters to 3
    const schoolList = document.querySelector('.school-list-element');
    if (schoolList) {
        const letterItems = schoolList.querySelectorAll('.school-letter');
        const loadMoreBtn = schoolList.querySelector('.section_loadmore');
        // Anzahl sichtbare Buchstaben aus Data-Attribut am Container oder Default 3
        let visibleCount = 3;
        if (schoolList.dataset.visiblelettercount) {
            visibleCount = parseInt(schoolList.dataset.visiblelettercount, 10) || 3;
        }

        // Funktion zum Berechnen/Aktualisieren der Höhen
        function updateLetterHeights(isExpanded) {
            letterItems.forEach((item, idx) => {
                if (isExpanded || idx < visibleCount) {
                    item.classList.add('school-letter--visible');
                    // scrollHeight neu auslesen für aktuelle Fenstergröße
                    const currentHeight = item.scrollHeight;
                    item.style.maxHeight = (isExpanded ? currentHeight + 40 : currentHeight) + 'px';
                } else {
                    item.classList.remove('school-letter--visible');
                    item.style.maxHeight = null;
                }
            });
        }

        // Hide all except first visibleCount (mit Animation)
        letterItems.forEach((item, idx) => {
            item.classList.add('school-letter--init');
        });

        updateLetterHeights(false);

        // Entferne Init-Klasse nach kurzem Timeout, damit keine Animation beim Laden
        setTimeout(() => {
            letterItems.forEach(item => {
                item.classList.remove('school-letter--init');
            });
        }, 50);

        if (loadMoreBtn) {
            // Button-Text aus data-Attribut oder HTML
            const showMoreText = loadMoreBtn.getAttribute('data-showmore') || loadMoreBtn.innerText || 'Mehr anzeigen';
            const showLessText = loadMoreBtn.getAttribute('data-showless') || 'Weniger anzeigen';
            let expanded = false;
            loadMoreBtn.innerText = showMoreText;
            loadMoreBtn.addEventListener('click', function () {
                expanded = !expanded;
                updateLetterHeights(expanded);
                loadMoreBtn.innerText = expanded ? showLessText : showMoreText;
            });
        }

        // Bei Fenstergrößenänderung Höhen neu berechnen
        let resizeTimeout;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                // Aktuellen Zustand (expanded oder nicht) beibehalten
                const currentlyExpanded = loadMoreBtn && loadMoreBtn.innerText === (loadMoreBtn.getAttribute('data-showless') || 'Weniger anzeigen');
                updateLetterHeights(currentlyExpanded);
            }, 250);
        });
    }
});
